import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { WorksheetStatistics } from '../types/worksheet';

type UseOtherSchedulesOverviewResult = {
    overview: WorksheetStatistics;
};

async function getOtherSchedulesOverview(workpaperId: string): Promise<UseOtherSchedulesOverviewResult> {
    const { data } = await api.get(`/workpapers/${workpaperId}/other-schedules/overview`);
    return data;
}

export function useOtherSchedulesOverview(): UseQueryResult<UseOtherSchedulesOverviewResult, AxiosError> {
    const { id: workpaperId } = useWorkpaperContext();
    return useQuery([workpaperId, 'other-schedules', 'overview'], () => getOtherSchedulesOverview(workpaperId), {
        keepPreviousData: true,
    });
}